import React from 'react';
import Footer from './../Footer';
import { Link, withRouter } from 'react-router-dom';

import { Pages, Settings } from './Pages';

class Chapter1 extends React.Component {

	constructor(props) {
		super(props);

		this.page = Pages[2];
		this.handleTogglePopout = this.handleTogglePopout.bind(this);

		this.handlePopoutImages = this.handlePopoutImages.bind(this);
		this.popImages = [
			`${process.env.PUBLIC_URL}/images/ink-blotter-lg.jpg`,
			`${process.env.PUBLIC_URL}/images/bank-ink-blotter-lg.jpg`,
			`${process.env.PUBLIC_URL}/images/canfield-passbook-lg.jpg`,
			`${process.env.PUBLIC_URL}/images/report-of-condition.jpg`
		];
	}

	handlePopoutImages = e => {
		this.props.popoutImages(e);
	}

	handleTogglePopout = popout => {
		this.props.togglePopout(popout);
	}

	componentDidMount() {
		this.props.bgHoverState(this.page.color);
		this.props.imageObjects(document.querySelectorAll(Settings.imageSelectors));

		this.props.gatherImages(this.popImages);

		document.title = `${this.page.name.replace('<br />', '')} | Peapack 100 Anniversary`;
		document.body.className = "page-inner page-chapter-1";
	}

	render() {
		return  (
			<div className="page-wrapper">
				<div className="page">
					<div className="header-section wrapper">
						<div className="row">
							<div className="col-left col-md-6">
								<div className="header-content">
									<Link to="/" onClick={this.props.bgHoverState} className="back-button">Back</Link>
									<h1 dangerouslySetInnerHTML={{ __html: this.page.name }} />
									<div className="caption line">Main Street, looking north, Gladstone circa 1915 (courtesy of Peter Welsh)</div>
								</div>
							</div>
							<div className="col-right col-md-6">
								<figure className="header-thumbnail anim-up">
									<img src={`${process.env.PUBLIC_URL}/images/first-100-years.jpg`} alt="" />
								</figure>
							</div>
						</div>
					</div>
					<div className="white-background entry-content">
						<div className="wrapper">
							<div className="row row9 line-border">
								<div className="col-lg-8">
									<div className="row row9">
										<div className="col-sm-6">
											<figure className="full loaded-image mb-sm-0">
												<img src={`${process.env.PUBLIC_URL}/images/Natirar-1.jpg`} alt="" />
											</figure>
										</div>
										<div className="col-sm-6">
											<figure className="full loaded-image mb-sm-0">
												<img src={`${process.env.PUBLIC_URL}/images/Natirar-2.jpg`} alt="" />
											</figure>
										</div>
									</div>
								</div>
								<div className="col-lg-4">
									<div className="caption dark">
										<div className="pt-xl-4">
											<span className="roman">Natirar</span>, built in 1912 by Katherine Everit Macy and Walter Graeme Ladd, was one of the largest estates in The Somerset Hills. The nearly 1,000-acre property contained a 30,000 square foot mansion, several outbuildings, and two miles of the North Branch of the Raritan River. (courtesy of Jim Stadtmueller)
										</div>
									</div>
								</div>	
							</div>
							<div className="row">
								<div className="col-md-8">
									<h3>Seeds Are Sown for a Community Bank</h3>
									<p>In 1920, the United States was emerging from the dark times of World War I and looking forward to the new decade. As he campaigned for the presidency of the United States, Warren G. Harding urged his fellow Americans to embrace a “return to normalcy”—a normalcy that included economic growth and modernization. </p>
									<p>Optimism permeated the growing hamlet of Peapack-Gladstone. With a diverse population of 1,200 citizens including farmers, merchants, professionals, and tradespeople, the village was home to a range of thriving stores, farms, churches, and schools. And it was surrounded by magnificent country estates.</p>
									<p>Only one essential institution was missing from the commercial hub: a local bank. In the early part of the twentieth century, only five banks served all of Somerset County. To cash a paycheck or get money for groceries, a resident of Peapack-Gladstone had to make the long trek to a bank in Somerville, Bernardsville, or Whitehouse Station.</p>
								</div>
							</div>
						</div>
					</div>
					<div className="brown-background entry-content">
						<div className="wrapper">
							<h3 className="mb-5">An all-day visit to the Bank</h3>
							<div className="row row10 figure-grid">
								<div className="item col-md-8 order-md-1">
									<figure className="popout-image" onClick={this.handlePopoutImages}>
										<img src={`${process.env.PUBLIC_URL}/images/ink-blotter-lg.jpg`} alt="" />
									</figure>
								</div>
								<div className="col-md-8 order-md-3">
									<div className="caption line pt-4">An ink blotter advertisement for Layton’s Trackless Trolly (courtesy of Marge Dzwonczyk)</div>
								</div>
								<div className="item col-md-4 order-md-2">
									<figure style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/ink-blotter-2.jpg`}}></figure>
								</div>
								<div className="col-md-4 order-md-4">
									<div className="caption pt-4">A bad day for the D, L & W line, occurring between Peapack and Far Hills (courtesy of Jim Stadtmueller)</div>
								</div>
							</div>
							<br />
							<div className="row row10">
								<div className="col-md-8">
									<p>For Peapack-Gladstone residents in the early part of the twentieth century, a trip to the bank could turn into an all-day affair. Limited transportation options included:</p>
									<p><strong>Train:</strong> Peapack-Gladstone was served by two railroads: the Rockaway Valley Railroad and the D, L &amp; W. By 1913, the Rockaway Valley Railroad (affectionally dubbed the Rockabye Baby Railroad, as it was known to rock and sway along its hilly and uneven route) had ceased operation, leaving no rail link to Whitehouse Station, where many Peapack-Gladstone businessmen chose to bank. Riding the D, L &amp; W line to a Bernardsville bank was an option generally avoided by Peapack-Gladstone residents, perhaps because of local business rivalries.</p>
									<p><strong>Stage:</strong> The Peapack Stage, which had offered service between Peapack and Somerville since the nineteenth century, gave way to Layton’s Trackless Trolley in 1909. Initially, the “trolley” was no more than a four-seated stagecoach pulled by a team of black horses. Within two years, owner George Layton acquired a two-cylinder, five-passenger automobile to provide transportation between Far Hills and Somerville.</p>
									<p><strong>Automobile:</strong> By 1909, several Peapack-Gladstone residents had acquired “horseless carriages.” Yet poor road conditions limited the ability to travel safely and dependably, especially in bad weather. In fact, for many automobile owners, winter travel was out of the question. Cars were placed on blocks and “overwintered” in a shed, without a battery.</p>
								</div>
								<div className="col-md-4">
									<figure className="full">
										<img src={`${process.env.PUBLIC_URL}/images/main-street.jpg`} alt="" />
										<figcaption>Main Street, Peapack circa 1916. The building contained the Peapack post office and a “department store.” (courtesy of  Peter Welsh)</figcaption>
									</figure>
								</div>
							</div>
						</div>
					</div>
					<div className="white-background entry-content">
						<div className="wrapper">
							<div className="row">
								<div className="col-md-8">
									<h3>The Founding of Peapack-Gladstone Bank</h3>
									<p>By 1920, leaders in Peapack-Gladstone sought a more efficient, safe, and local banking option for their growing community. Led by Ellis Tiger and Garner F. Hill, these visionary founders believed that a new bank would succeed if it was fully invested in the community and operated with the highest ethical standards.</p>
								</div>
							</div>
							<br />
							<div className="pullout-text mb-5 pr-md-6">
								The principles of “Trust and Integrity” espoused by the founders have become the foundation on which Peapack-Gladstone Bank has operated throughout its proud 100-year history.
							</div>
							<br />
							<div className="row">
								<div className="col-md-8">
									<p>Early in 1921, a series of public meetings was held to gauge local interest in the establishment of an independent bank in town. An item in the Peapack <em>Weekly Exponent</em> on February 3, 1921, made it known that “progressive citizens have taken steps to organize a bank in the borough. This is a very wise step and the project is taking rapid form and results are expected real soon.” The paper further reported,</p>
									<blockquote>A public meeting was held last Friday evening and strong support was promised. . . . A committee was appointed to solicit the borough and neighboring towns to determine the amount of stock that could be sold. A bank of $50,000 capital and $25,000 surplus fund is being considered. . . . The greatest difficulty confronting them is a building and it is thought that the erection of a building will be necessary.</blockquote>
									<p>Members of the committee included a “who’s who” of local businessmen and professionals, including officers William J. Woodhead, President; Ellis Tiger, Treasurer; and Lloyd Teets, Secretary; as well as William C. Horton, Dr. M. C. Smalley, D. H. Van Doren, Elmer C. Courter, Henry Cordes, John Allen, Garner F. Hill, Walter Ballentine, Walter Ludlow, C. M. Riker, E. C. Willets, George Lindabury, and George Layton. A number of these men would remain closely associated with the Bank and the community for years to come.</p>
									<h3>Embraced by Community Investors</h3>
									<p>Local residents eagerly awaited an announcement of the opportunity to purchase bank stock, believing that bank stock was universally one of the best investments in the world. Citizens of the twin borough were not alone in their curiosity about the proposed community bank. <em>The Bernardsville News</em> closely followed developments related to the formation of a potential rival to the well-established Bernardsville National Bank. The paper reported that stock shares would be offered at $120 each and that the “fifteen members of the organizational committee have pledged themselves for 100 shares. As the shares are selling for $120 par value with surplus, this will permit a capitalization of $120,000, with a surplus of $4,000.” Within one week, the stock was oversubscribed. Shares were allotted and payments collected as the committee prepared to apply for a bank charter.</p>
									<p>In May 1921, it was reported that the anticipated bank of Peapack and Gladstone received the “necessary papers from Washington, D.C. to permit them to go ahead” relatively quickly.</p>
									<h3>Building the Bank</h3>
									<p>One critical issue remained before the committee: a final decision on the location of the new bank building. Most members preferred a central location close to the firehouse. Discussion focused on whether to rent an existing building or build anew. Several options were considered.</p>
									<p>The Board ultimately accepted an offer from G. F. Hill to construct a shared building on pastureland he owned adjacent to his garage operation. This was considered an optimal location as it was located midway between the commercial centers of Peapack and Gladstone. Ground was broken at 219 Main Street, Gladstone, on May 9, 1921, less than four months after the founders first met. Designed to be fireproof, the structure was constructed of concrete, steel, and brick. As anticipated in an article in the <em>Weekly Exponent</em>, the structure “will have a forty foot frontage and will be sixty feet deep.” The building was divided into two separate concerns with the bank occupying the east side and G. F. Hill & Co.’s hardware and feed store occupying the west side. As building owner, Mr. Hill charged the Bank $50 in monthly rent. A pair of apartments occupied the upper floor of the property. The original bank building continued to house Peapack-Gladstone Bank operations well into the 1990s.</p>
								</div>
							</div>
						</div>
					</div>
					<div className="brown-background entry-content pb-5">
						<div className="wrapper">
							<div className="row row20">
								<div className="col-lg-8">
									<figure className="full">
										<img src={`${process.env.PUBLIC_URL}/images/building-the-bank.jpg`} alt="" />
										<figcaption>219 Main Street with Peapack-Gladstone National Bank on left and G. F. Hill & Co. on right (Peapack-Gladstone Bank archives)</figcaption>
									</figure>
								</div>
								<div className="col-lg-4">
									<div className="spacer d-lg-block d-none"></div>
									<h3>Bank Directors Appointed</h3>
									<p>The original Directors of Peapack-Gladstone National Bank included Ellis Tiger, William D. Van Derbeek, Edwin C. Willets, Dr. Mahlon C. Smalley, George C. Lindabury, George R. Layton, Harry Cordes, G. F. Hill, and William J. Woodhead. The daily operations would be managed by the Bank’s first officers: Ellis Tiger, President; William Van Derbeek, First Vice President; E. C. Willetts, Second Vice President; and Lloyd Teets, temporary secretary.</p>
								</div>
							</div>
						</div>
					</div>
					<div className="white-background entry-content">
						<div className="wrapper">
							<div className="row">
								<div className="col-md-8">
									<figure className="full">
										<div className="popout-image" onClick={this.handlePopoutImages}>
											<img src={`${process.env.PUBLIC_URL}/images/bank-ink-blotter-lg.jpg`} alt="" />
										</div>
										<figcaption className="line">Peapack-Gladstone National Bank ink blotter (Peapack-Gladstone Bank archives)</figcaption>
									</figure>
									<h3>STAFFING THE NEW Bank</h3>
									<p>One of the first employees hired by the Directors filled the important position of Bank Cashier—the person responsible for managing all monies and valuables of the Bank. A talented young man from the Summit Trust Company, Robert “Bert” P. Williamson, who had twelve years of bank experience under his belt, was engaged as Cashier of the new organization. The Directors also hired a bookkeeper, Eleanor Smalley.</p>
									<h3>Opening Day on September 12, 1921</h3>
								</div>
							</div>
							<div className="row">
								<div className="col-md-8">
									<p>Citizens flocked to the opening day ceremonies at what <em>The Bernardsville News</em> described as the "handsome new building" at 219 Main Street. The officers and Directors of the fledgling institution and the Head Cashier were on hand to greet patrons. The Bank opening was heralded by the local press, with <em>The Bernardsville News</em> noting the convenience that a local bank would afford the community and suggesting that "it should also be the means of helping to boost the already progressive and up-to-date borough of Peapack and Gladstone."</p>
									<p>Bank hours were set as Monday through Friday, 9 a.m. to 3 p.m., and Saturday from 9 a.m. until noon. At the close of business on opening day, the total deposits were calculated to be $8,664.76. The Bank’s first passbook savings account was issued to Edith Tiger Canfield, a daughter of Ellis Tiger.</p>
								</div>
								<div className="col-md-4">
									<div className="row row9">
										<div className="col-lg-6 col-md-12 col-sm-6">
											<figure className="img text-center popout-image" onClick={this.handlePopoutImages}>
												<img src={`${process.env.PUBLIC_URL}/images/canfield-passbook-lg.jpg`} alt="" />
											</figure>
										</div>
										<div className="col-lg-6 col-md-12 col-sm-6 d-flex">
											<div className="caption align-self-center">A 1949 replacement book for Edith Tiger Canfield’s passbook savings account #1 (courtesy of Susan Neill Boyer)</div>
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-md-8">
									<figure className="dollars">
										<img src={`${process.env.PUBLIC_URL}/images/ten-dollars.jpg`} alt="" />
										<img src={`${process.env.PUBLIC_URL}/images/ten-dollars-back.jpg`} alt="" />
									</figure>
									<div className="caption line">Front and back of a $10 Peapack-Gladstone National Bank Note. When Peapack-Gladstone National Bank was formed in 1921, six kinds of paper currency were in circulation: United States Notes, National Bank Notes, Federal Reserve Notes, Federal Reserve Bank Notes, Gold Certificates, and Silver Certificates. (Peapack-Gladstone Bank archives)</div>
									<h3>Bank Governance</h3>
									<p>The tradition of a monthly Board of Directors meeting was established immediately. The Bank conducted its inaugural Board meeting as an operating entity at 8 p.m. on September 16, 1921. Handwritten meeting minutes were maintained; among other business matters recorded at the Directors’ first meeting was the fact that “Mr. Woodhead made motion that we purchase a revolver to have in the Banking Room. Seconded by Mr. Cordes. Carried.” Even though Peapack-Gladstone was far removed from the haunts of the notorious bank robbers of the time—like John Dillinger and Pretty Boy Floyd—the Directors were taking no chances with the community’s money.</p>
								</div>
								<div className="col-md-4 d-flex">
									<div className="align-self-end">
										<figure className="img popout-image" onClick={this.handlePopoutImages}>
											<img src={`${process.env.PUBLIC_URL}/images/report-of-condition.jpg`} alt="" />
										</figure>
										<div className="caption">Peapack-Gladstone National Bank Report of Condition at the Close of Business on December 31, 1921 (Peapack-Gladstone Bank archives)</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<Footer togglePopout={this.handleTogglePopout} />
				</div>
			</div>
		)
	}
}

export default withRouter(Chapter1);